import { api } from "services/rpc/RpcProvider";

interface DateRange {
  startDate?: string;
  endDate?: string;
}

export const useAnalyticsData = (dateRange: DateRange = {}) => {
  const overview = api.analytics.overview.useQuery(dateRange, {
    keepPreviousData: true
  });

  const workflows = api.analytics.workflows.useQuery(dateRange, {
    keepPreviousData: true
  });

  const categories = api.analytics.categories.useQuery(dateRange, {
    keepPreviousData: true
  });

  return {
    overview: {
      data: overview.data,
      isLoading: overview.isLoading,
      error: overview.error
    },
    workflows: {
      data: workflows.data,
      isLoading: workflows.isLoading,
      error: workflows.error
    },
    categories: {
      data: categories.data,
      isLoading: categories.isLoading,
      error: categories.error
    },
    isLoading: overview.isLoading || workflows.isLoading || categories.isLoading,
    error: overview.error || workflows.error || categories.error
  };
};
